// src/helpers/statusHelper.js

import i18n from '@/i18n'

export function getStatusInfo(status) {
  const t = i18n.global.t
  const statusMap = {
    'registered': { title: t('trainings.status.registered'), color: 'bg-label-primary' },
    'started': { title: t('trainings.status.inProgress'), color: 'bg-label-primary' },
    'in-progress': { title: t('trainings.status.inProgress'), color: 'bg-label-warning' },
    'chapter-quiz': { title: t('trainings.status.inProgress'), color: 'bg-label-primary' },
    'final-quiz': { title: t('trainings.status.inProgress'), color: 'bg-label-primary' },
    'pending': { title: t('trainings.status.pending'), color: 'bg-label-warning' },
    succeeded: { title: t('trainings.status.succeededFeminine'), color: 'alert-success' },
    failed: { title: t('trainings.status.failed'), color: 'alert-danger' },
    cancelled: { title: t('trainings.status.cancelled'), color: 'alert-danger' },
    expired: { title: t('trainings.status.expired'), color: 'alert-secondary' },
    other: { title: t('trainings.status.unknown'), color: 'alert-secondary' },
  };

  return statusMap[status] || { title: t('trainings.status.unknown'), color: 'bg-label-primary' };
}
